import Swiper from 'swiper';
import {sliders} from "./config";

export default function sliderSwiper({main, on, elm, state}) {
    const data = state.get();
    const sliderConfig = sliders[data.type];
    if (data.thumbs) {
        const thumbsSlider = document.getElementById(data.thumbs);
        sliderConfig['thumbs'] = {
            swiper: thumbsSlider.swiper
        };
    }

    const slider = new Swiper(elm, sliderConfig);

    main(() => {
        if (data.type === 'cars') {
            slider.on('activeIndexChange', carsActiveIndexChange);
        }
    });

    const carsActiveIndexChange = function() {
        const index = this.activeIndex;
        const parent = this.el.closest('.cars');

        const items = [...parent.querySelectorAll('.cars__item')];
        items.forEach(el => el.classList.remove('cars__item--active'));

        const item = items.find(el => +el.dataset.index === index);
        item.classList.add('cars__item--active');

        const title = item.querySelector('.cars__title').textContent;
        parent.querySelector('.cars__heading').textContent = title;
    };
}

export const model = ({elm}) => {
    return {
        type: elm.dataset.slider,
        thumbs: elm.dataset.thumbs ?? false
    };
};